<template>
<div>
    <v-toolbar flat color="white">
        <v-tabs v-model="tab">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab>
                Organisations
            </v-tab>
            <v-tab>
                Subscription Setup
            </v-tab>
        </v-tabs>
        <v-list-tile v-if="xeroUrl" :href="xeroUrl">
            <v-list-tile-avatar>
                <v-img contain src="xero_logo.svg"></v-img>
            </v-list-tile-avatar>
            <v-list-tile-sub-title>
                Connect to Xero
            </v-list-tile-sub-title>
        </v-list-tile>
    </v-toolbar>
    <div v-if="tab==0">
        <v-data-table :items="organisations" :headers="headers" style="cursor: pointer">
            <template v-slot:items="props">
                <td>
                    <v-img :src="props.item.logo" contain style="max-height: 75px" @click="routeToOrganisation(props.item)"></v-img>
                </td>
                <td class="text-xs-center" @click="routeToOrganisation(props.item)">{{props.item.name}}</td>
                <td class="text-xs-center" @click="routeToOrganisation(props.item)">{{props.item.locationNetworks}}</td>
                <td class="text-xs-center" @click="routeToOrganisation(props.item)">{{props.item.activeServiceAccounts}}</td>
                <td class="text-xs-center" @click="routeToOrganisation(props.item)">{{props.item.locationsPassed}}</td>
                <td class="text-xs-center" @click="routeToOrganisation(props.item)">{{props.item.locations}}</td>

            </template>
        </v-data-table>
    </div>
    <div v-else-if="tab==1">
        <v-data-table :items="plans" :headers="planHeaders" style="cursor: pointer">
            <template v-slot:items="props">
                <td class="text-xs-center">
                    <v-layout justify-center>
                        <v-btn small icon @click="editSubscription(props.item)">
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn small icon>
                            <v-icon small>delete</v-icon>
                        </v-btn>
                    </v-layout>
                </td>
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.type}}</td>
                <td class="text-xs-center">{{props.item.pricePerUnit | currency}}</td>
            </template>
        </v-data-table>
    </div>

    <v-dialog v-model="subscriptionModal" persistent width="750px">
        <v-card v-if="item&&item.type">
            <v-toolbar flat color='white'>
                <v-toolbar-title>
                    {{item.modalType}} Subscription
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.id" outline color="black" @click="createSubscription()">Save</v-btn>
                <v-btn v-else outline color="black" @click="updateSubscription()">Save</v-btn>

                <v-btn flat @click="subscriptionModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <v-flex xs5 mx-1>
                        <v-text-field label="Name" v-model="item.name" box style="font-size: 14px"></v-text-field>

                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-select dense label="Type" v-model="item.type" :items="planTypes" box style="font-size: 14px"></v-select>

                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-select box style="font-size: 14px" v-model="item.accountType" label="Account Type" :items="['Item', 'Account']"></v-select>
                    </v-flex>
                    <v-flex xs5 mx-1>
                        <v-autocomplete v-if="item.accountType=='Account'" box v-model="item.xeroAccountCode" ref="accounts" color="black" clearable v-on:blur="$refs['accounts'].blur()" label="Linked Account" :items="accountingAccounts" item-text="name" item-value="id"></v-autocomplete>

                        <v-autocomplete v-else box v-model="item.xeroAccountCode" ref="items" color="black" clearable v-on:blur="$refs['items'].blur()" label="Linked Item" :items="accountingItems" item-text="name" item-value="id"></v-autocomplete>

                    </v-flex>
                     <v-flex xs5 mx-1>
                        <v-text-field label="Price per Unit" box v-model="item.pricePerUnit"></v-text-field>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "../services/Api";
import dateformat from "dateformat";
export default {
    data: () => ({
        accountingItems: [],
        accountingAccounts: [],
        subscriptionModal: false,
        item: {},
        organisations: [],
        planTypes: ['Active Service Accounts', 'Installed Locations'],
        headers: [{
                text: "",
                align: "center",
                sortable: false
            },
            {
                text: "Customer",
                align: "center",
                value: "name",
            },
            {
                text: "Networks",
                align: "center",
                value: "locationNetworks"
            },
            {
                text: "Active Service Accounts",
                align: "center",
                value: "activeServiceAccounts"
            },
            {
                text: "Units Passed",
                align: "center",
                value: "locationsPassed"
            },
            {
                text: "Units",
                align: "center",
                value: "locations"
            }
        ],
        planHeaders: [{
                text: "Action",
                align: "center",
                sortable: false
            },
            {
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Type",
                align: "center",
                value: "type"
            },
            {
                text: "Price per Unit",
                align: "center",
                value: "pricePerUnit"
            }
        ],
        plans: [],
        tab: 0,
        xeroUrl: null
    }),
    created() {
        this.fetchBillableOrganisations()
        this.getXeroLoginUrl()
        this.getGluePlans()
    },
    methods: {
        addSubscription() {
            this.item = {
                modalType: 'Add',
                accountType: 'Item'
            }
            this.subscriptionModal = true
        },
        createSubscription(){
          Api().post('/admin/createPlan', this.item).then(res=>{
            this.subscriptionModal = false
            this.item={}
            this.getGluePlans()
          })
        },
        updateSubscription(){
          Api().put('/admin/updatePlan/'+this.item.id, this.item).then(res=>{
            this.subscriptionModal = false
            this.item={}
            this.getGluePlans()
          })
        },
        editSubscription(item) {
            this.item = item
            this.item.modalType = 'Edit'
            this.subscriptionModal = true
        },
        getXeroLoginUrl() {
            // debugger
            if (this.$route.query.code) {
                this.getXeroTokens()
            } else {
                Api().get('/xero/admin/authenticate').then(response => {
                    if (response.data.url) {
                        this.xeroUrl = response.data.url
                    } else {
                        this.fetchXeroAccounts()
                        this.fetchXeroItems()
                    }
                })
            }
        },
        getXeroTokens() {
            Api().get('/xero/admin/callback', {
                params: this.$route.query
            }).then(response => {
                if (response.data.tokenSet) {
                    // this.xeroAuth = response.data.tokenSet
                    // this.getXeroOrganisations()
                }
            })
        },
        fetchBillableOrganisations() {
            Api().get('/admin/billableOrganisations').then(res => {
                this.organisations = res.data
                console.log(res.data)
            })
        },
        async fetchXeroAccounts() {
            await Api().get('/xero/admin/accounts').then(res => {
                let result = res.data.body.accounts
                this.accountingAccounts = result.map(x => ({
                    id: x.code,
                    name: x.name
                }))
            })
        },
        async fetchXeroItems() {
            await Api().get('/xero/admin/items').then(res => {
                let result = res.data.body.items

                this.accountingItems = result.map(x => ({
                    id: x.code,
                    name: x.name
                }))
            })
        },
        getGluePlans() {
            Api()
                .get("/admin/gluePlans")
                .then((response) => {
                    this.plans = response.data;
                });
        },
        routeToOrganisation(org) {
            this.$router.push({
                path: '/glueBilling/' + org.id
            })
        }
    }
}
</script>
